import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "wallet-data-list sm:w-22rem" }
const _hoisted_2 = {
  key: 0,
  class: "flex align-items-center justify-content-between mb-s3 text-sm text-danger"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "ml-2 mr-3" }, [
  /*#__PURE__*/_createTextVNode(" Wrong network."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Switch to Milkomeda Cardano C1 ")
], -1)
const _hoisted_4 = { class: "wallet-panel-data" }
const _hoisted_5 = { class: "flex align-items-center justify-content-between text-sm" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "caption" }, "Your wallet", -1)
const _hoisted_7 = { class: "wallet-address-panel px-s4 mt-s2" }
const _hoisted_8 = { class: "mr-s3" }
const _hoisted_9 = { class: "flex mt-s4 justify-content-between text-sm" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted" }, "BLUES balance", -1)
const _hoisted_11 = {
  key: 1,
  class: "white-space-nowrap"
}
const _hoisted_12 = { class: "flex mt-s4 justify-content-between text-sm" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted" }, "MilkADA balance", -1)
const _hoisted_14 = {
  key: 1,
  class: "white-space-nowrap"
}
const _hoisted_15 = {
  key: 1,
  class: "panel-warning mt-s3 p-s3 text-sm"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-bolder" }, "Low milkADA balance"),
  /*#__PURE__*/_createElementVNode("div", null, "You need milkADA for transactions fees")
], -1)
const _hoisted_17 = { class: "flex align-items-center justify-content-between text-sm mt-s3" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "caption" }, "Connected with", -1)
const _hoisted_19 = { class: "flex align-items-center text-sm mt-s1" }

import ExternalLink from '@/components/ExternalLink.vue';
import { useBluesBalance } from '@/composables/core/useBluesBalance';
import { useWallet } from '@/composables/core/useWallet';
import { useAddressLink } from '@/composables/core/useAddressLink';
import { useFormattedAddress } from '@/composables/utils/useFormattedAddress';
import { switchNetwork } from '@/helpers/blockchain-utils';
import CopyIcon from '@/components/CopyIcon.vue';
import Icon from '@/components/Icon.vue';
import { computed } from 'vue';
import InfoMessage from '@/components/InfoMessage.vue';


export default /*#__PURE__*/_defineComponent({
  emits: ["openDialog"],
  setup(__props, { emit: emits }: { emit: ({
  (e: 'openDialog'): void;
}), expose: any, slots: any, attrs: any }) {

const {
  address,
  connector,
  isNetworkError,
  getFirstSupportedNetwork,
  balance,
} = useWallet();
const formattedAddress = useFormattedAddress(address);
const { balanceFormatted, balanceLoading } = useBluesBalance();
const explorerLink = useAddressLink();
const onSwitchNetwork = () => {
  switchNetwork(getFirstSupportedNetwork());
};
const isBaseTokenBalanceTooLow = computed(() => balance.value < 0.01);
const baseTokenBalance = computed(() =>
  isBaseTokenBalanceTooLow.value ? '<0.01' : balance.value.toFixed(2),
);


return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Skeleton = _resolveComponent("Skeleton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isNetworkError))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(Icon, {
            name: "danger",
            size: "16",
            class: "align-self-start"
          }),
          _hoisted_3,
          _createVNode(_component_Button, {
            label: "Switch",
            class: "button-base ml-auto",
            onClick: onSwitchNetwork
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(ExternalLink, {
          icon: "",
          label: "View in Explorer",
          url: _unref(explorerLink)
        }, null, 8, ["url"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(formattedAddress)), 1),
        _createVNode(CopyIcon, {
          data: _unref(address),
          class: "text-muted"
        }, null, 8, ["data"])
      ]),
      (!_unref(isNetworkError))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              (_unref(balanceLoading))
                ? (_openBlock(), _createBlock(_component_Skeleton, {
                    key: 0,
                    class: "w-7rem"
                  }))
                : (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_unref(balanceFormatted)), 1))
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              (_unref(balanceLoading))
                ? (_openBlock(), _createBlock(_component_Skeleton, {
                    key: 0,
                    class: "w-7rem"
                  }))
                : (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_unref(baseTokenBalance)), 1))
            ])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    (_unref(isBaseTokenBalanceTooLow) && !_unref(isNetworkError))
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createVNode(InfoMessage, {
            type: "warning",
            size: "12"
          }, {
            default: _withCtx(() => [
              _hoisted_16
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_17, [
      _hoisted_18,
      _createElementVNode("div", _hoisted_19, [
        _createVNode(Icon, {
          name: _unref(connector).icon,
          size: "14",
          class: "mr-s1"
        }, null, 8, ["name"]),
        _createElementVNode("span", null, _toDisplayString(_unref(connector).name), 1)
      ])
    ]),
    _createVNode(_component_Button, {
      class: "button-base w-full ml-auto mt-s3",
      label: "Disconnect",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('openDialog')))
    })
  ]))
}
}

})